import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigurationService } from '../../services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {

  constructor(protected http: HttpClient,
    protected configurations: ConfigurationService) {
  }

  save(department: any) {
    return this.http.post(this.configurations.apiAddress + "/api/Department/save", department);
  }

  search(searchText: string) {
    let myParams = new HttpParams()
      .set('searchText', searchText == undefined ? "" : searchText)
    return this.http.get(this.configurations.apiAddress + '/api/Department/search', { params: myParams });
  }

  delete(id: number) {
    return this.http.delete(this.configurations.apiAddress + '/api/Department/delete/' + id);
  }

  getById(id: number) {
    return this.http.get(this.configurations.apiAddress + '/api/Department/getById/' + id);
  }

  getAll() {
    return this.http.get(this.configurations.apiAddress + '/api/Department/getAll/');
  }
}
